module.exports = __webpack_public_path__ + "img/btn_icon_leave.eb96f6c.png";